import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createRiderValidationForm } from "../../utils/validationSchema";
import TextField from "../Reusable/Form/TextInput";
import Form from "../../layouts/Form";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/Form/ComboboxInput/userCombobox";

const CreateRider = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createRiderValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <ComboboxInput
          url={APIS.USER}
          queryKey={"user"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"User"}
          setValue={setValue}
          placeholder={"Search user"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"License Number"}
          register={register("license_number")}
          errors={errors?.license_number}
        />
        <TextField
          label={"Ctitizenship Number"}
          register={register("citizen_ship_number")}
          errors={errors?.citizen_ship_number}
        />
      </div>
    </Form>
  );
};

export default CreateRider;
